import React, { FC, useCallback } from 'react'
import { ConfirmationModal, IModalAction } from 'transfix-ui'

interface IControlPanelDeleteModalProps {
  open: boolean
  onClose: (action: string, id: string | number | null) => void
  id: string | number | null
}

const ACTIONS: IModalAction[] = [
  {
    label: 'Cancel',
    type: 'dismiss',
  },
  {
    label: 'Delete',
    type: 'confirm',
  },
]

const ControlPanelDeleteModal: FC<IControlPanelDeleteModalProps> = ({ id, onClose, open }) => {
  const onCloseHandler = useCallback(
    action => {
      if (action) {
        onClose(action, id)
      }
    },
    [id, onClose]
  )

  return (
    <ConfirmationModal
      size={3}
      open={open}
      actions={ACTIONS}
      onClose={onCloseHandler}
      dataTest='delete-confirmation'
      title='Are you sure you want to delete this issue type?'
    />
  )
}

export default ControlPanelDeleteModal
